import { AssetTypeTaxCode } from "./constants/securspace-constants";

interface EquipmentTypeItem {
  name: string;
  assetType: string;
  available: 0 | 1;
  icon: string;
}

interface LocationEquipmentType {
  equipmentType: string;
  id?: string | null;
  pricePerDay?: number | null;
  pricePerWeek?: number | null;
  pricePerMonth?: number | null;
  replacedType?: string | null;
  customPrice?: boolean;
  [key: string]: unknown;
}

const EquipmentTypes = {
  OPTIONS: [
    "Container/Chassis (20'/40'/45')",
    "Container/Chassis (40'/45'/53')",
    "Container/Chassis (20'/40')",
    "Container/Chassis (45')",
    "Truck + Trailer",
    "Truck Only",
    "Truck Only (25')",
    "Trailer (53')",
    "Refrigerated Plug In"
  ] as string[],

  OPTIONS_CONDENSED: [
    "Container/Chassis (20'/40'/45')",
    "Container/Chassis (40'/45'/53')",
    "Truck + Trailer",
    "Truck Only",
    "Truck Only (25')",
    "Trailer (53')",
    "Refrigerated Plug In"
  ] as string[],

  jsonTypes: [
    {"name": "Container/Chassis (20'/40'/45')", "assetType": "Container/Chassis (20'/40'/45')",  "available": 1 as const,  "icon":"container.png"},
    {"name": "Container/Chassis (40'/45'/53')", "assetType": "Container/Chassis (40'/45'/53')",  "available": 1 as const,  "icon":"container.png"},
    {"name": "Container/Chassis (20'/40')", "assetType": "Container/Chassis (20'/40')",  "available": 1 as const,  "icon":"container.png"},
    {"name": "Container/Chassis (45')", "assetType": "Container/Chassis (45')",  "available": 1 as const,  "icon":"container.png"},
    {"name": "Truck + Container/Chassis", "assetType": "Truck + Container/Chassis", "available": 0 as const, "icon":"truck-container.png"},
    {"name": "Truck + Trailer", "assetType": "Truck + Trailer",  "available": 1 as const,"icon":"truck-trailer.png"},
    {"name": "Truck Only", "assetType": "Truck Only",  "available": 1 as const,"icon":"truck-only.png"},
    {"name": "Truck Only (25')", "assetType": "Truck Only (25')",  "available": 1 as const,"icon":"truck-only.png"},
    {"name": "Trailer (53')", "assetType": "Trailer (53')",  "available": 1 as const,"icon":"53-trailer.png"},
    {"name": "Refrigerated Plug In", "assetType": "Refrigerated Plug In", "available": 1 as const,"icon":"refrigerated.png"}
  ] as EquipmentTypeItem[],

  getEqType(assetType: string | null | undefined): string {
    return assetType ? assetType : "Container/Chassis";
  },

  getIconByName(name: string): string {
    const item = this.jsonTypes.find(item => item.name === name);
    return item?.icon || "";
  },

  getCondensedAssetTypeTaxCodes(): { [key: string]: typeof AssetTypeTaxCode[keyof typeof AssetTypeTaxCode] } {
    return Object.entries(AssetTypeTaxCode).reduce<{ [key: string]: typeof AssetTypeTaxCode[keyof typeof AssetTypeTaxCode] }>((acc, [key, value]) => {
      if (this.OPTIONS_CONDENSED.includes(value)) {
        acc[key] = value;
      }
      return acc;
    }, {});
  },

  getRatesByEqType(
    selectedAssetType: string | null | undefined,
    locationEqTypes: LocationEquipmentType[]
  ): LocationEquipmentType | null {
    if (locationEqTypes.length === 0) return null;

    const eqType = this.getEqType(selectedAssetType);
    if (!eqType) return null;
    let selectedEq: LocationEquipmentType | null = null;
    for (let i = 0; i < locationEqTypes.length; i++) {
      if (locationEqTypes[i]['equipmentType'] === eqType) {
        selectedEq = locationEqTypes[i];
        break;
      }
    }
    return selectedEq;
  },

  sortLocationEquipmentTypes(temp: LocationEquipmentType[]): LocationEquipmentType[] {
    temp.sort((a: LocationEquipmentType, b: LocationEquipmentType) => {
      const nameA = a.equipmentType.toLowerCase();
      const nameB = b.equipmentType.toLowerCase();
      if (nameA < nameB) return -1;
      if (nameA > nameB) return 1;
      return 0;
    });
    return temp;
  }
};

export type { EquipmentTypeItem, LocationEquipmentType };
export default EquipmentTypes;
